import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../../CustomComponents/Loader';
import { useLocation, useNavigate } from 'react-router-dom';
import { withOidcSecure } from '@axa-fr/react-oidc';
import HomeLayout from '../../../Layout/HomeLayout';
import HomeHeader from '../../../CustomComponents/HomeHeader';
import { useKeyDown } from '../../../../hooks/useKeyDown';
import { ACTIVATE_CARD_INLIFE,GENERATE_ACTIVATE_CARD_OTP, GENERATE_EXISTING_PHONE_EMAIL_OTP, GENERATE_OTP_CHANGE_PIN, GENERATE_OTP_VIEW_CARD, GET_ADD_NEW_CARD_METADATA, GET_CARDHOLDER_CARDS, GET_PIN_CHANGE_DETAILS, GET_SHIPPING_ID, LOCK_CARD_API, POST_LOGIN, POST_PIN_CHANGE, REPLACE_CARD_API, REPORT_LOST_CARD_API, STATUS_SUCCESS_CODE, UNLOCK_CARD_API, GET_RECCURING_TRANSACTIONS, GET_RECURRING_TRANSACTIONS_DETAILS } from '../../../../network/URLConstants';
import { GetApiHeadersWithBearer, GetRequest, PostRequest } from '../../../../network/NetworkUtils';
import CustomAlertModel from '../../../CustomComponents/CustomAlertModel';
import { appTheme, retrieveData } from '../../../../helpers/utils/Utils';
import Custom2FA from '../../../CustomComponents/Custom2FA';
import Modal from '../../../CustomComponents/Modal';
import { LOGIN_SESSION_KEY } from '../../../../Redux/reducers';
import CustomTextInput from '../../../CustomComponents/CustomtextInput';
import { addLineBreaks, displayErrorMessage, displayKudzuplusErrorMessage } from '../../../../utils';
import CardMenu from '../../CardMenu';
import DynamicCard from '../../../CustomComponents/DynamicHomeCard';
import { width } from "../../../CustomComponents/Card/CardStyles";
import CardHeading from '../../../CustomComponents/CardHeading';

import Tooltip from '../../../Tootltip';
import TransactionItemWidget from '../../../CustomComponents/TransactionItemWidget';
import { Tabs, Tab } from '../../../CustomComponents/TabsComponent';
import moment from 'moment';
import logFirebaseEvents from '../../../LogFirebaseEvents';
import { CheckingAndSavingsHeader, AccountDetailsHeder, copyToClipboard, formatDateToMMDDYYYY, SPENDING } from '../../../../utils';
import { useCallback } from 'react';
import debounce from 'lodash.debounce';
import Cookies from 'js-cookie';
import { TRANSACTIONS, CHECKING, GET_DDA_DETAILS, GENERATE_UNLOCK_CARD_OTP, UPCOMINGTRANSACTIONS, GETTRANSACTIONDETAILS  } from '../../../../network/URLConstants';
import { CHECKING_CARD_CODE } from '../../../../helpers/utils/Utils';
import UpcomingTransactionItemWidget from '../../../CustomComponents/UpcomingTransactionItemWidget';
import warningImg from '../../../../assets/images/warning.png'
import FilterSlider from '../../../CustomComponents/Slider';
import { useDocumentTitle } from '../../../../hooks/useDocumentTitle';
const ManageRecurringPayments = () => {
    
    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
    const { t } = useTranslation(); // Hook to access translation functions    
    useDocumentTitle(t('page_title_recurring_payments'));
    const dispatch = useDispatch();
    const appThemeData = appTheme(kudzuPlusTrue)
    
    const cards = useSelector(state => JSON.parse(state.userCards));
    const accessTokenToApi = useSelector(state => state.accessToken);
    const [isOTPVerifyModalOpen, setIsOTPVerifyModalOpen] = useState(false);
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate();
    const [showModel, setShowModel] = useState(false);
    const HighlightMsgStyles = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal  text-[var(--modal-text-highlight)] cursor-pointer pointer-events-none";
    const HeaderMsgStyles = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal cursor-pointer pointer-events-none text-[var(--modal-text-heading-clr)]";
    const SubHeaderMsgStyles = "font-hanken-grotesk text-[var(--modal-text-heading-clr)] modal-title lg:text-[20px] md:text-[18px] sm:text-[14px] text-[16px] font-normal cursor-pointer pointer-events-none";
    const [highlightMsg, setHighlightMsg] = useState('')
    const [headerMsg, setheaderMsg] = useState('')
    const [subHeaderMsg, setSubHeaderMsg] = useState('')
    const [btn1Exists, setBtn1Exists] = useState(false)
    const [btn2Exists, setBtn2Exists] = useState(false)
    const [btn1Text, setBtn1Text] = useState(false)
    const [btn2Text, setBtn2Text] = useState('')
    const [modelImage, setModelImage] = useState('')
    const [btn1TypeAcpt, setBtn1TypeAcpt] = useState(false)
    const [footerMsg, setFooterMsg] = useState('');
    const [btn1Focus, setBtn1Focus] = useState(false);
    const [btn2Focus, setBtn2Focus] = useState(false);
    const [subFooter, setSubFooter] = useState('');
    const location = useLocation();
    const [setupPinURL, setSetupPinURL] = useState('');
    const [showSetupPinWebPage, setShowSetupPinWebPage] = useState(false);
    const [showActivateCard, setShowActivateCard] = useState(false);
    const [UpdatedArray, setUpdatedArray] = useState(useSelector(state => JSON.parse(state.userCards)));
    const [showResponse, setShowResponse] = useState(false);
    const [isBorderNone, setisBorderNone] = useState(true);
    const [showErrorImg, setshowErrorImg] = useState(false);
    

    const cardDetails = useSelector(state => state.selectedCardDetails);


    useEffect(() => {
        setShowActivateCard(true)
    }, []);


    useEffect(() => {
        // Listen for messages from the embedded iframe
        const handleMessage = (event) => {
            if (event.data == 0) {
                setSetupPinURL('')
                // updateCardStatus(selectedItem.CardKey, responseObj.Response)
                setShowSetupPinWebPage(true);
                callPostPinChangeApi(event.data)
                // Handle success case
            } else if (event.data == -1) {
                setShowSetupPinWebPage(true);
                setSetupPinURL('')
                callPostPinChangeApi(event.data)
                // Handle failure case
            }
        };

        window.addEventListener('message', handleMessage);

        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, []);


    useKeyDown(() => { }, ["Enter"]);
    const showAlertModal = (showModel, highlightMsg, headerMsg, subHeaderMsg, btn1Exists, btn2Exists, btn1Text, btn2Text, btn1TypeAcpt, modelImage, footerMsg, showErrorImg, isBorderNone, btn1Focus, btn2Focus) => {
        setshowErrorImg(showErrorImg)
        setisBorderNone(isBorderNone)
        setShowModel(showModel)
        setHighlightMsg(highlightMsg)
        setheaderMsg(headerMsg)
        setSubHeaderMsg(subHeaderMsg)
        setBtn1Exists(btn1Exists)
        setBtn2Exists(btn2Exists)
        setBtn1Text(btn1Text)
        setBtn2Text(btn2Text)
        setBtn1TypeAcpt(btn1TypeAcpt)
        setModelImage(modelImage)
        setFooterMsg(footerMsg)
        setBtn1Focus(btn1Focus)
        setBtn2Focus(btn2Focus)
    }
    const handleCardAction = (type) => {
        if (type == t('lock_card')) {
            showAlertModal(true, t("are_you_sure"), t("this_card_will_be_locked"), t('once_you_lock_your_card_any_new_transactions_will_be_declined'), true, true, t('lock_card'), t("cancel"), true, require('../../../../assets/images/lock_green.png'), '', false, true, false, true)
        } else if (type == t('unlock_card')) {
            showAlertModal(true, t("ready_to_unlock_questionmark"), t("unlock_your_card_to_resume_normal_use"), t('once_you_unlock_your_card_all_locked'), true, true, t('unlock_card'), t("cancel"), true, require('../../../../assets/images/unlock_green.png'), '', false, true, true, false)
        } else if (type == t('replace_card')) {
            navigate('/CardServices/CardActionScreen/ReplaceCard', { state: { item: cardDetails } })
        } else if (type == t('change_pin')) {
            navigate('/CardServices/CardActionScreen/ChangePin', { state: { item: cardDetails } })
        } else if (type == t('view_card_details')) {
            navigate('/CardServices/CardActionScreen/ViewCard', { state: { item: cardDetails } })
        } else if (type == t('activate_card')) {
            navigate('/CardServices/CardActionScreen/ActivateCard', { state: { item: cardDetails } })
        }
        // Archived - Manage Recurring Payments replaced with Stop a Recurring Payment (call support flow)
        // else if(type === t('CARD_SERVICE_MANAGE_RECURRING_PAYMENTS')){
        //     navigate('/CardServices/CardActionScreen/ManageRecurringPayments', { state: { item: cardDetails } })
        // }
        else if(type === t('STOP_A_RECURRING_PAYMENT')){
            navigate('/CardServices/CardActionScreen/StopPaymentCallSupport', { state: { item: cardDetails } })
        }

    }
    const onAcptBtnClick = () => {
        if (btn1Text == t("lock_card")) {
            callApiToLockCard()
        } else if (btn1Text == t("unlock_card")) {
            callApiToUnlockCard()
        } else if (btn1Text == t('back_to_card_services')) {
            navigate('/CardServices')
        } else if (btn1Text == t('home')) {
            navigate('/home')
        }
    }
    const onCancelBtnClick = () => {
        if (btn2Text == 'Cancel') {
            setShowModel(false)
        } else if (btn2Text == t('back_to_card_services')) {
            navigate('/CardServices')
        }
    }
    const closeOTPVerifyModal = () => { setIsOTPVerifyModalOpen(false) }
    const closeModel = () => {
        if (showModel && (btn1Text == t('back_to_card_services') || btn2Text == t('back_to_card_services'))) { navigate('/CardServices') } else { setShowModel(false); }
    }
    const verificationSuccess = () => {
        setShowActivateCard(true)
        setShowResponse(false); setShowSetupPinWebPage(false);
    }
    const generate2FAOtp = async () => {
        const deviceId = await retrieveData('updatedDeviceId');
        const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);

        const requestObject = {
            cardKey: cards !== null ? cards[0].CardKey : 0
        };

        const url = GENERATE_ACTIVATE_CARD_OTP;
        setLoading(true);

        try {
            const response = await PostRequest(url, requestObject, headers);
            setLoading(false);

            const parsedResponse = JSON.parse(response);
            if (parsedResponse.ResponseCode === STATUS_SUCCESS_CODE) {
                const loginSessionPayLoad = { loggedSessionKey: parsedResponse.Response.sessionId }
                dispatch({ type: LOGIN_SESSION_KEY, payload: loginSessionPayLoad });
                const userIdPayload = { userId: parsedResponse.Response.userId }
                dispatch({ type: 'USER_ID', payload: userIdPayload });
                setTimeout(() => {
                    setIsOTPVerifyModalOpen(true);
                }, 1000);
            } else {
                const arrMessages = parsedResponse.Messages;
                const message = arrMessages[0];
                const displayText = message.DisplayText;
                setShowActivateCard(false)
                showAlertModal(true, t("oops_exclamation"), '', displayText, true, true, t('home'), t('back_to_card_services'), true, require('../../../../assets/images/warning.png'), '', false, false, true, false)
               
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const callApiToLockCard = async () => {
        setLoading(true)
        setShowModel(false)


        const deviceId = await retrieveData('updatedDeviceId');
        const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
        let object = {
            CardKey: cardDetails !== null ? cardDetails.CardKey : 0
        }
        PostRequest(LOCK_CARD_API, object, headers).then((response) => {

            setTimeout(() => {
                setLoading(false)
            }, 500);

            let responseObj = JSON.parse(response);
            if (responseObj.ResponseCode == STATUS_SUCCESS_CODE) {

                setTimeout(() => {
                    updateCardStatus(cardDetails !== null ? cardDetails.CardKey : 0, responseObj.Response)
                    showAlertModal(true, t("done_exclamation"), t("this_card_is_now_locked"), t('any_new_tx_will_be_declined'), true, false, t('back_to_card_services'), '', true, require('../../../../assets/images/lock_green_tick.png'), '', false, false, true, false)
                }, 1000);


            } else {
                var arrMessages = responseObj.Messages;
                var message = arrMessages[0];
                var displayText = message.DisplayText;
                showAlertModal(true, t("oops_exclamation"), '', displayText, true, true, t('home'), t('back_to_card_services'), true, require('../../../../assets/images/warning.png'), '', false, false, true, false)
                setTimeout(() => {
                }, 1000);

            }

        });

    }

  const callApiToUnlockCard = async () => {
        setLoading(true)
        setShowModel(false)
        const deviceId = await retrieveData('updatedDeviceId');
        const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
        let object = {
            CardKey: cardDetails.CardKey
        }

        PostRequest(UNLOCK_CARD_API, object, headers).then((response) => {
            setTimeout(() => {
                setLoading(false)
            }, 500);
            let responseObj = JSON.parse(response);
            if (responseObj.ResponseCode == STATUS_SUCCESS_CODE) {
                setTimeout(() => {
                    updateCardStatus(cardDetails.CardKey, responseObj.Response)
                    showAlertModal(true, t("success_heading"), t("this_card_is_now_unocked"), t('you_can_use_your_card'), true, false, t('back_to_card_services'), '', true, require('../../../../assets/images/unlock_green_tick.png'), '', false, false, true, false)
                }, 1000);
            } else {
                var arrMessages = responseObj.Messages;
                var message = arrMessages[0];
                var displayText = message.DisplayText;
                showAlertModal(true, t("oops_exclamation"), '', displayText, true, true, t('home'), t('back_to_card_services'), true, require('../../../../assets/images/warning.png'), '', false, false, true, false)
                setTimeout(() => {
                }, 1000);
            }
        });
    }

    const updateCardStatus = (cardKey, response, type) => {
        const updatedCardIndex = cards?.findIndex(card => card.CardKey === cardKey);
        if (updatedCardIndex !== -1) {
            const updatedCard = {
                ...cards[updatedCardIndex],
                Status: response.Status,
                SubStatus: response.SubStatus,
                StatusCode: response.StatusCode,
                SubStatusCode: response.SubStatusCode,
            };
            if (type == t('activate_card') && response.CardDisplayNumber != undefined && response.CardDisplayNumber != null) { updatedCard.CardDisplayNumber = response.CardDisplayNumber }
            if (type == t('activate_card')) {
                updatedCard.CardKey = response.CardKey;
            }
            const updatedArray = [updatedCard, ...cards.filter(card => card.CardKey !== cardKey)]
            setUpdatedArray(updatedArray);
            dispatch({ type: 'UPDATE_USER_CARDS', payload: { userCards: JSON.stringify(updatedArray) } });
            dispatch({ type: 'SELECTED_USER_CARD_DETAILS', payload: { selectedCardDetails: updatedCard } });

        }
    };

    async function callPostPinChangeApi(status) {
        const deviceId = await retrieveData('updatedDeviceId');
        const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
        const url = POST_PIN_CHANGE + "cardKey=" + cardDetails?.CardKey + "&language=en";

        const body = {
            Success: status == 0 ? true : false,
            ProviderResponse: status == 0 ? "200-0" : ("400-" + status)
        }

        const response = await PostRequest(url, body, headers)
        const responseObj = JSON.parse(response)

        if (responseObj.ResponseCode == STATUS_SUCCESS_CODE) {
            if (responseObj.Response.Success) {
                showAlertModal(true, t("perfect_exclimation"), addLineBreaks(t("your_4_digit_pin_has_been_set_you_may_now")), '', true, false, t('back_to_card_services'), '', true,
                    kudzuPlusTrue ? require('../../../../assets/kudzu-plus-images/Activation_lock.png') : require('../../../../assets/images/activate_change_lock.png'),
                    '', false, false, true, false)
            } else {
                showAlertModal(true, t("oops_exclamation"), '', 'pin Setup Failed', true, true, t('home'), t('back_to_card_services'), true, require('../../../../assets/images/warning.png'), '', false, false, true, false)
            }

        } else {
            var arrMessages = responseObj.Messages;
            var message = arrMessages[0];
            var displayText = message.DisplayText;
            showAlertModal(true, t("oops_exclamation"), '', displayText, true, true, t('home'), t('back_to_card_services'), true, require('../../../../assets/images/warning.png'), '', false, false, true, false)

        }
    }

    const getCardDisplayName = (card) => {
    const name = card.NickName ? card.NickName : card.AccountTypeName;
    const endsWithDashDigits = /-\s*\d+$/.test(card.NickName || '');
    const displayNum = card.CardDisplayNumber || "";
    const hasRealDigits = /\d/.test(displayNum);
    const lastFour = (!endsWithDashDigits && hasRealDigits)
        ? displayNum.replace(/\D/g, '').slice(-4)
        : '';

    return (
        <>
            {name}
            {lastFour && (
                <span className="text-[12px] text-[#8A8A8A] ml-1">
                    ..{lastFour}
                </span>
            )}
        </>
    );
};


// Upcoming  transactions

  const currentPath = window.location.pathname;
  const pageSize = location.pathname === '/home' ? 5 : 10;
  const isMountedRef = useRef(false);
  const currentDate = new Date();
  const minDate = new Date(currentDate);
  minDate.setMonth(currentDate.getMonth() - 6); // Minimum date is 6 months ago
  const maxDate = new Date(); // Maximum date is today
  const [cardData, setCardData] = useState([]);
  const defaultFilterData = { minAmnt: '0', maxAmnt: '500', debit: true, credit: true, minDate: moment(new Date(currentDate).setMonth(currentDate.getMonth() - 6)).format('MM-DD-YYYY'), maxDate: moment(new Date()).format('MM-DD-YYYY') };
  const [filterData, setFilterData] = useState(defaultFilterData);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItemsCount, setTotalItemsCount] = useState(0);
  const [totalPages, setTotalPages] = useState('');
  const [CardNumber, setCardNumber] = useState('');
  const [CardBalance, setCardBalance] = useState('');
  const [showItems, setShowItems] = useState(false);
  const [CardText, setCardText] = useState('');
  const [checkingAccountNumber, setCheckingAccountNumber] = useState('*********'); //Account Number
  const [checkingRoutingNumber, setCheckingRoutingNumber] = useState('*********');
  const [isViewAllClicked, setIsViewAllClicked] = useState(false);
  const [showFilterOverlay, setShowFilterOverlay] = useState(false);
  const [quickActions, setQuickActions] = useState(true)
  const [labelDisable, setLabelDisable] = useState(false);
  const [selectedTab, setSelectedTab] = useState(t('ACTIVE'));
  const [SearchV, setSearchV] = useState('');
  const [upComingDisable, setUpcomingDisable] = useState(false);
  const [activityDisable, setActivityDisable] = useState(false);
  const [filterEnable, setFilterEnable] = useState(true);
  const [isFilterApplied, setIsFilterApplied] = useState(false)
  const [cardDetailsUp, setCardDetails] = useState({})
  
  ///navigation
  const handleNavigateToChecking = () => {
    //debugger; 
    navigate('/' + SPENDING + '')
  };


  const footerStyles = "underline font-hanken-grotesk cursor-pointer text-center pt-8 text-[var(--text-clr-transactions-viewall)] font-bold lg:text-[18px] md:text-[17px] sm:text-[14px] text-[14px] leading-[18px] absolute md:bottom-24 bottom-[3rem] left-1/2 -translate-x-1/2 cursor-pointer";
  const footerStylesNoRecords = "font-hanken-grotesk cursor-pointer pt-8 font-[500] md:font-[500]  lg:text-[18px] md:text-[18px] sm:text-[12px] text-[14px] leading-[18px] opacity-[75%]";

  useEffect(() => {
    global.selectedType = 'Active';
  }, [])

  // search
  const debouncedSubmitSearch = useCallback(
    debounce(async (SearchVal, currentFilterData) => {
      if (global.isFromApplyFilter !== undefined) {
        if (global.isFromApplyFilter) {
          global.isFromApplyFilter = false
          return
        }
      }
      dispatch({ type: 'CLOSE_ICON_FROM_STORE', payload: { closeIconFromStore: false } });
      setLoading(true);
      setSearchV(SearchVal);
      // const cardKey = cards?.[0].CardKey;
      var cardKey;
      for (var i = 0; i < cards?.length; i++) {
        if (cards?.[i].AccountTypeBit63 == CHECKING_CARD_CODE) {
          cardKey = cards?.[i].CardKey;
          break;
        }
      }

      if (global.selectedType === "Active") {
        const transactionData = await fetchTransactionsData(cardKey, 1);
        setCardData(transactionData);
        
      } else {
        const transactionData = await fetchUpcomingTransactionsData(cardKey, 1);
        setCardData(transactionData);
      }
      setTimeout(() => {
        dispatch({ type: 'CLOSE_ICON_FROM_STORE', payload: { closeIconFromStore: true } });
      }, 200)

      setLoading(false);

    }, 600), // 3000ms debounce time (30 seconds)
    [] 
  );

  const handleSubmitSearch = (value) => {
    if (value === '') {
      debouncedSubmitSearch.cancel();
      debouncedSubmitSearch('', filterData);
    } else {
      debouncedSubmitSearch(value, filterData);
    }
  };

  const Footer = () => {
    // alert(cardData.length);
    // debugger;
    return (

      <div>
        {/* {showItems && (currentPath === '/home') && cardData.length > 0 && (
          <div className={footerStyles} onClick={handleNavigateToChecking}>
            {(t('viewAll'))}
          </div>
        )} */}
        {showItems && (currentPath !== '/' + SPENDING + '') && totalPages !== 0 && cardData.length > 0 && (
          <div className={footerStyles} onClick={handleLoadMore}>
            {(t('viewAll'))}
          </div>
        )}
        {showItems && cardData.length === 0 && totalPages == 0 && (
          <div className={`${footerStylesNoRecords} ${currentPath === '/home' ? 'text-center text-[#559C7E]' : 'text-left  text-[#4B70B9]'}`}>
            {(t('notransaction'))}
          </div>
        )}
      </div>
    );
  };

  /////get account details
  const getAccountNumberDetails = async (cardType, cardkey) => {
    if (cardkey == undefined || cardkey == null) {
      return
    }
    setLoading(true);
    let url = GET_DDA_DETAILS + cardkey;
    const deviceId = await retrieveData('updatedDeviceId');
    const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
    var response = await GetRequest(url, headers)
    setTimeout(() => {
      setLoading(false)
    }, 500);
    var responseObj = JSON.parse(response);
    if (responseObj.ResponseCode == STATUS_SUCCESS_CODE) {
      if (responseObj.Response != undefined) {
        if (cardType == CHECKING || SPENDING) {
          setCheckingAccountNumber(responseObj.Response.ExternalSVAID != undefined ? responseObj.Response.ExternalSVAID : '--');
          setCheckingRoutingNumber(responseObj.Response.RoutingNumber != undefined ? responseObj.Response.RoutingNumber : '--');
        }

      }
    } else {
      var arrMessages = responseObj.Messages;
      var message = arrMessages[0];
      var displayText = message.DisplayText;
    }
  }

  
  // Function to fetch transaction data with filters 
  const fetchTransactionsData = async (cardKey, currentPage) => {
    if (cardKey == undefined) {
      return
    }
    if (SearchV == undefined) {
      SearchV = '';
    }
    try {
      if (cardKey == undefined || cardKey == null) {
        return
      }
      setLoading(true);
      const deviceId = await retrieveData('updatedDeviceId');
      const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
      const formattedMaxAmt = filterData.maxAmnt == '500' ? `${filterData.maxAmnt}+` : filterData.maxAmnt;
  const response = await GetRequest(
        GET_RECCURING_TRANSACTIONS(cardKey, pageSize, currentPage, 'ACT'),
        headers
      );
      const responseObj = JSON.parse(response);

      if (responseObj.ResponseCode === STATUS_SUCCESS_CODE) {
        setShowItems(true);
        setLoading(false);
        const totalPages = responseObj.Response.Pager.TotalPages;
        const RespcurrentPage = responseObj.Response.Pager.CurrentPage;
        const TotalItemsCount = responseObj.Response.Pager.TotalItems;
        if (responseObj.Response.RecurringTransactions > 0) {
          setLabelDisable(false);
          setActivityDisable(false);
        } else if (responseObj.Response.RecurringTransactions === 0) {
          setLabelDisable(false);
          if (isFilterApplied) {
            setActivityDisable(false);
          } else if (SearchV != undefined && SearchV != "") {
            setActivityDisable(false);
          } else {
            setActivityDisable(true);
          }
        }

        setTotalPages(totalPages);
        setCurrentPage(RespcurrentPage);
        setTotalItemsCount(TotalItemsCount);

        if (currentPage * pageSize <= TotalItemsCount) setIsViewAllClicked(true);
        else setIsViewAllClicked(false);

      
        const transactionItems = responseObj?.Response?.RecurringTransactions;
        return transactionItems;
      } else {
        setLoading(false);
        setLabelDisable(false);
        setActivityDisable(false);

        return [];
      }
    } catch (error) {
      setLoading(false);
      return [];
    }
  };

  const cancelTransaction = async (transactionData) => {
    var cardKey;
    for (var i = 0; i < cards?.length; i++) {
      if (cards?.[i].AccountTypeBit63 == CHECKING_CARD_CODE) {
        setCardText(cards?.[i].NickName ? cards?.[i].NickName : cards?.[i].AccountTypeName);
        setCardNumber(cards?.[i].CardDisplayNumber);
        setCardBalance(cards?.[i].Balance);
        cardKey = cards?.[i].CardKey;
        // setCardDetails(cards?.[i])
      }
    }

    if (cardKey == undefined) {
      return
    }

    try {
      if (cardKey == undefined || cardKey == null) {
        return
      }
      setLoading(true);
      const deviceId = await retrieveData('updatedDeviceId');
      const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
      var temmpUrl = GET_RECURRING_TRANSACTIONS_DETAILS(transactionData.TransactionId, cardKey);
      const response = await GetRequest(
        GET_RECURRING_TRANSACTIONS_DETAILS(transactionData.TransactionId, cardKey),
        headers
      );
      const responseObj = JSON.parse(response);
      if (responseObj.ResponseCode === STATUS_SUCCESS_CODE) {
        const responceObject = responseObj.Response;
        setLoading(false);
        const spendingCardDetails = cards?.find(item => item.AccountTypeBit63 === CHECKING_CARD_CODE);
        if (spendingCardDetails) { responceObject['cardDetails'] = spendingCardDetails }
        dispatch({ type: 'CANCEL_TRANSFER_DETAILS', payload: { cancelTransactionDetails: JSON.stringify(responceObject) } });
        navigate('/CardServices/CardActionScreen/ManageRecurringPayments/details')
      } else {
        setLoading(false);
        var arrMessages = responseObj.Messages;
        var message = arrMessages[0];
        var displayText = message.DisplayText;
        showAlertModal(true, t("oops_exclamation"), '', displayText, true, true, 'Ok', '', true, warningImg, '', false, false, true, false)
      }
    } catch (error) {
      setLoading(false);
      return [];
    }
  };

  const fetchUpcomingTransactionsData = async (cardKey, currentPage) => {
    if (cardKey == undefined) {
      return
    }

    try {
      if (cardKey == undefined || cardKey == null) {
        return
      }
      setLoading(true);
      const deviceId = await retrieveData('updatedDeviceId');
      const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
      const formattedMaxAmt = filterData.maxAmnt == '500' ? `${filterData.maxAmnt}+` : filterData.maxAmnt;
      const response = await GetRequest(
        GET_RECCURING_TRANSACTIONS(cardKey, pageSize, currentPage, 'INA'),
        headers
      );
      // debugger;
      const responseObj = JSON.parse(response);
      if (responseObj.ResponseCode === STATUS_SUCCESS_CODE) {
         setShowItems(true);
        setLoading(false);
        const totalPages = responseObj.Response.Pager.TotalPages;
        const RespcurrentPage = responseObj.Response.Pager.CurrentPage;
        const TotalItemsCount = responseObj.Response.Pager.TotalItems;
         if (responseObj.Response.RecurringTransactions.length > 0) {
          setLabelDisable(false);
          setUpcomingDisable(false);
          setFilterEnable(true)
        } else if (responseObj.Response.RecurringTransactions.length === 0) {
          setLabelDisable(false);
          if (isFilterApplied) {
            setUpcomingDisable(false);
          } else if (SearchV != undefined && SearchV != "") {
            setUpcomingDisable(false);
          } else {
            setUpcomingDisable(true);
          }
        }

        setTotalPages(totalPages);
        setCurrentPage(RespcurrentPage);
        setTotalItemsCount(TotalItemsCount);

      if (currentPage * pageSize <= TotalItemsCount) setIsViewAllClicked(true); 
      else setIsViewAllClicked(false);
        const transactionItems = responseObj?.Response?.RecurringTransactions;
        return transactionItems;
      } else {
        setLabelDisable(true);
        setLoading(false);
        setUpcomingDisable(true);

        var arrMessages = responseObj.Messages;
        var message = arrMessages[0];
        var displayText = message.DisplayText;
        return [];
      }
    } catch (error) {
      setLoading(false);
      return [];
    }
  };

  const displayViewAllBasedOnTotalItemCounts = () => {
    if (showItems) {
      if (currentPage * pageSize <= totalItemsCount) setIsViewAllClicked(true);
      else setIsViewAllClicked(false);

    }
  }

  ///on load get the data
  useEffect(() => {
    // debugger;
    if (!isMountedRef.current) {
      const fetchData = async () => {
        // defaultFilterData.maxAmnt='500+'
        await fetchInitialData(CHECKING, currentPage, defaultFilterData, SearchV);
      };
      fetchData();
      isMountedRef.current = true;
    }
  }, []);


  ///get transactions data
  const fetchInitialData = async (cardType, currentPage, filterData, SearchV) => {
     setLoading(true);
    if (SearchV == undefined) {
      SearchV = '';
    }

   let cardKey;
  for (let i = 0; i < cards?.length; i++) {
    if (cards?.[i].AccountTypeBit63 == CHECKING_CARD_CODE) {
      setCardText(cards?.[i].NickName ? cards?.[i].NickName : cards?.[i].AccountTypeName);
      setCardNumber(cards?.[i].CardDisplayNumber);
      setCardBalance(cards?.[i].Balance);
      cardKey = cards?.[i].CardKey;
      setCardDetails(cards?.[i]);
      break; 
    }
  }

    // Fetch account details only once and store them in state
    if (checkingAccountNumber !== '' && checkingRoutingNumber !== '') {
      await getAccountNumberDetails(cardType, cardKey);
    }
    var transactionData;
    if (selectedTab == t('ACTIVE')) {
      transactionData = await fetchTransactionsData(cardKey, currentPage);
    } else {
      transactionData = await fetchUpcomingTransactionsData(cardKey, currentPage);
    }

    // If it's the first page, set the transaction data as it is
    if (currentPage === 1) {
      setCardData(transactionData);
      setLoading(false);
    } else {
      // If it's not the first page, append the new transactions to the existing data
      setCardData((prevCardData) => [...prevCardData, ...transactionData]);
      setLoading(false);
    }

  };


  //load more data
  const handleLoadMore = async () => {
    const newCurrentPage = currentPage + 1;
    setCurrentPage(newCurrentPage);
    try {
      await fetchInitialData(CHECKING, newCurrentPage, filterData, SearchV);
    } catch (error) {
      // Handle error, if any
      console.error(error);
      setLoading(false);
    }
  };

  const onCloseFilter = () => {
  
    setQuickActions(!quickActions);
    if (currentPath === '/home') {
      setShowFilterOverlay(true);
      handleNavigateToChecking();
      logFirebaseEvents("Home", "filter_Closed", "filter_Closed", "", "");

    } else {
      setShowFilterOverlay((prevState) => !prevState);
      logFirebaseEvents("Spendings", "filter_Closed", "filter_Closed", "", "");
   

    }

  }

  ////filters 
  const handleFilterClick = (activeTab) => {
    dispatch({ type: 'SEARCH_FILTER_VALUE', payload: { SearchFiltervalue: global.searchValueFromGlobal } });
 
    setQuickActions(!quickActions);
    if (currentPath === '/home') {
      setShowFilterOverlay(true);
      handleNavigateToChecking();
      logFirebaseEvents("Home", "filter_Clicked", "filter_Clicked", "", "");
      setShowFilterOverlay((prevState) => !prevState);
      logFirebaseEvents("Spendings", "filter_Clicked", "filter_Clicked", "", "");

    }
  };

  useEffect(() => {
    if (showFilterOverlay) setIsViewAllClicked(true)
    else displayViewAllBasedOnTotalItemCounts();

  }, [showFilterOverlay])
  //load more data

  const aplliedTabFunction = async (appliedTab) => {
    // alert(appliedTab)
    setCurrentPage(1);
    setSelectedTab(appliedTab);
    global.selectedType = appliedTab;
    if (appliedTab == t('ACTIVE')) {
      if (currentPath === "/home") {
        logFirebaseEvents("Home", "Activity_Clicked", "Activity_Clicked", "", "");
      }
      else {
        logFirebaseEvents("Spendings", "Activity_Clicked", "Activity_Clicked", "", "");
      }
      dispatch({ type: 'SELECTED_CARD_TAB', payload: { selectedCardTab: t('ACTIVE') } });
      var cardKey;
      for (var i = 0; i < cards?.length; i++) {
        if (cards?.[i].AccountTypeBit63 == CHECKING_CARD_CODE) {
          setCardText(cards?.[i].NickName ? cards?.[i].NickName : cards?.[i].AccountTypeName);
          setCardNumber(cards?.[i].CardDisplayNumber);
          setCardBalance(cards?.[i].Balance);
          cardKey = cards?.[i].CardKey;
          setCardDetails(cards?.[i])
        }
      }

      const tabFreshFilterData = {
        minAmnt: '0',
        maxAmnt: '500',
        debit: true,
        credit: true,
        minDate: formatDateToMMDDYYYY(minDate),
        maxDate: formatDateToMMDDYYYY(maxDate)
      };
      setFilterData(tabFreshFilterData);
      const transactionData = await fetchTransactionsData(cardKey, 1);

      setCardData(transactionData);
      setLoading(false);
    } else if (appliedTab == t('IN_ACTIVITY')) {
      setActivityDisable(false);
      if (currentPath === "/home") {
        logFirebaseEvents("Home", "Upcoming_Clicked", "Upcoming_Clicked", "", "");
      }
      else {
        logFirebaseEvents("Spendings", "Upcoming_Clicked", "Upcoming_Clicked", "", "");
      }
      dispatch({ type: 'SELECTED_CARD_TAB', payload: { selectedCardTab: t('IN_ACTIVITY') } });
      var cardKey;
      for (var i = 0; i < cards?.length; i++) {
        if (cards?.[i].AccountTypeBit63 == CHECKING_CARD_CODE) {
          setCardText(cards?.[i].NickName ? cards?.[i].NickName : cards?.[i].AccountTypeName);
          setCardNumber(cards?.[i].CardDisplayNumber);
          setCardBalance(cards?.[i].Balance);
          cardKey = cards?.[i].CardKey;
          setCardDetails(cards?.[i])
        }
      }

      const tabFreshFilterData = {
        minAmnt: '0',
        maxAmnt: '500',
        debit: true,
        credit: true,
      };
      setFilterData(tabFreshFilterData);

      const transactionData = await fetchUpcomingTransactionsData(cardKey, 1);

      if (transactionData && transactionData.length < 0) {
        setUpcomingDisable(true);
      }
      setCardData(transactionData);
      setLoading(false);

    }
  }

  const handleApplyFilters = async (data) => {
    setUpcomingDisable(false);
    setActivityDisable(false);
    dispatch({ type: 'SEARCH_FILTER_VALUE', payload: { SearchFiltervalue: global.searchValueFromGlobal } });
    setIsFilterApplied(true)
    logFirebaseEvents("Spendings", "Apply_filters_clicked", "Apply_filters_clicked", "", "");
    setFilterData(data);
    setSearchV(global.searchValueFromGlobal)

    // Convert boolean values to "Y" (true) or "N" (false)
    const formattedDebit = data.debit ? 'true' : 'false';
    const formattedCredit = data.credit ? 'true' : 'false';


    // Ensure that minAmnt and maxAmnt are numbers
    const formattedMinAmnt = Number(data.minAmnt);
    const formattedMaxAmnt = Number(data.maxAmnt) === 500 ? `${Number(data.maxAmnt)}+` : Number(data.maxAmnt);
    const formattedMinDt = data.minDate;
    const formattedMaxDt = data.maxDate;


    // Construct the data object to be passed to the API
    const formattedFilterData = {
      minAmnt: formattedMinAmnt,
      // maxAmnt: formattedMaxAmnt + '+',
      maxAmnt: formattedMaxAmnt,
      debit: formattedDebit,
      credit: formattedCredit,
      minDate: formattedMinDt,
      maxDate: formattedMaxDt
    };

    // Clear existing data
    setCardData([]);
    setCurrentPage(1);

    // Fetch data for each card type (e.g., checking) with the updated filterData
    await fetchInitialData(CHECKING, 1, formattedFilterData, global.searchValueFromGlobal);
    setShowFilterOverlay(false);
    setQuickActions(!quickActions)

  };

  const handleClearFilters = async () => {
    logFirebaseEvents("Spendings", "Reset_filters", "Reset_filters", "", "");
    //alert('Clear Filters');
  };

  const steps = [
    'Tap here to search by transaction name',
    'Tap here for more search tool',
  ];
  const [currentStepSpending, setCurrentStepSpending] = useState(0);
  const [isTooltipVisibleSpending, setIsTooltipVisibleSpending] = useState(false);

  useEffect(() => {
    const tooltipCookieNameForSpending = `tooltipState_Spending${cards?.find(card => card.AccountTypeBit63 === CHECKING_CARD_CODE).CardKey}`;
    const tooltipStateSpending = Cookies.get(tooltipCookieNameForSpending);
    console.log('Initial tooltipStateSpending: from cookies', tooltipStateSpending);
    if (tooltipStateSpending === undefined || parseInt(tooltipStateSpending) < steps.length) {
      setCurrentStepSpending(parseInt(tooltipStateSpending) || 0);
      setIsTooltipVisibleSpending(true);
    } else {
      setIsTooltipVisibleSpending(false);
    }
  }, [steps.length]);


  const handleGotitWithSearchClick = () => {
    setIsTooltipVisibleSpending(false);
    // sessionStorage.setItem("tooltipState_Spending", 2);
    const tooltipCookieNameForSaving = `tooltipState_Spending${cards?.find(card => card.AccountTypeBit63 === CHECKING_CARD_CODE).CardKey}`;
    Cookies.set(tooltipCookieNameForSaving, 'true', { expires: 1825 }, 2);
  }

  useEffect(() => {
    if (cardData.length === 0 && SearchV && global.searchValueFromGlobal) {
      setUpcomingDisable(false);
      setActivityDisable(false);
    }
  }, [cardData, SearchV, global.searchValueFromGlobal,])

  useEffect(() => {
    setUpcomingDisable(false);
    setActivityDisable(false);
  }, [selectedTab])

    return (
      <HomeLayout>
        <CardMenu handleCardAction={handleCardAction} />
        <div className='md:w-[150px] sm:w-[30px] w-[0px]'></div>
        <div className='flex flex-col lg:w-[860px] md:w-[860px] sm:w-[464px] w-[100%] animate__animated animate__fadeInRight '>
          <DynamicCard
            header={!showSetupPinWebPage}
            CardRadius={true}
            footer={isViewAllClicked}
            footerContent={<Footer />}
            cardWidth={width.allpolicies}
            HeaderRadius={true}
            isWhite={appThemeData.isWhiteBgForCard}
            isDarkForKudzu={appThemeData.isDarkBgForCard}
            backgroundColor={'--cardHeading-bg'}
            HeaderContent={
              <>
                <CardHeading heading={t('CARD_SERVICE_MANAGE_RECURRING_PAYMENTS')} />
              </>
            }
          >
            <>
              <div className={`${kudzuPlusTrue ? '' : 'bg-[#A3CEBB]'} h-0.5 min-h-0.5 mt-4 sm:mx-0 mx-4 `}></div>
              <div className='flex flex-col items-between self-between 
                                               justify-between w-full h-full pb-8'>
                <div className='md:w-[100%] sm:w-[87%] w-full md:pt-10 pt-10'>
                  <p className={`font-hanken-grotesk mb-[50px] ${kudzuPlusTrue ? "text-white" : ""}`} >{t('CRAD_SERVICE_MANAGE_RECURRING_SUB_HEADING')}</p>
                  <p className={`font-hanken-grotesk text-[var(--addAccount-text)] font-[600]
                                               uppercase  lg:text-[13px] md:text-[12px] sm:text-[11px] text-[12px] font-[600]
                                               tracking-[2px] ${kudzuPlusTrue ? '' : 'opacity-[50%]'}   sm:mx-0 mx-4`}>{t("CARD USED")}
                  </p>
                  <p className={`font-hanken-grotesk text-[24px] font-[500] mb-[12px] mt-[30px] ${kudzuPlusTrue ? "text-white" : ""}`} >{getCardDisplayName(cardDetails)}</p>
                  <div className='sm:flex w-full md:mb-[3rem] sm:mb-8 mb-[12px]' >
                    <div className='sm:w-[50%] w-full sm:mb-0 mb-5 h-0.5 bg-[#E7E4DC]'>{ }</div>
                  </div>
                  {
                    showItems && !showFilterOverlay && (
                      <div className='sm:px-0 px-10 relative'>
                        <Tabs recurring={true}  space={true} gap={true} selectedTab={selectedTab} labelDisable={labelDisable} upComingDisable={upComingDisable} activityDisable={activityDisable} updateActiveTab={aplliedTabFunction} onFilterClick={handleFilterClick} showFilterAndsearch={true} cardType={t('checking')} isEnabled={(!isFilterApplied && cardData.length == 0 && SearchV == "") ? false : true}//
                          filterEnable={filterEnable} handleSubmitSearch={handleSubmitSearch} handleGotitWithSearchClick={handleGotitWithSearchClick} SearchVal={global.searchValueFromGlobal}>
                          <Tab label={t('ACTIVE')} >
                            {(cardData && cardData.length > 0) ?
                              cardData?.map((data) => {
                                return (
                                  <UpcomingTransactionItemWidget cancelUpcomingTransaction={cancelTransaction} transactionData={data} />
                                )
                              }) :
                              (cardData.length === 0 && SearchV) ? <div
                                className={`${footerStylesNoRecords} ${currentPath === '/home' ? 'text-center text-[var(--text-clr-no-transactions)]' : 'text-left text-[#4B70B9]'}`}
                              >{t('no_Transactions_Found_Invalid')}</div> :
                                <div className={`${footerStylesNoRecords} ${currentPath === '/home' ? 'text-center text-[var(--text-clr-no-transactions)]' : ' text-[#4B70B9] text-left'}`}>
                                  {(t('no_upcoming_transaction'))}
                                </div>}
                          </Tab>
                          <Tab label={t('IN_ACTIVITY')} >
                            {(cardData && cardData.length > 0) ?
                              cardData?.map((data) => {
                                return (
                                  <UpcomingTransactionItemWidget cancelUpcomingTransaction={cancelTransaction} transactionData={data} />
                                )
                              }) :
                              (cardData.length === 0 && SearchV) ? <div
                                className={`${footerStylesNoRecords} ${currentPath === '/home' ? 'text-center text-[var(--text-clr-no-transactions)]' : 'text-left text-[#4B70B9]'}`}
                              >{t('no_Transactions_Found_Invalid')}</div> :
                                <div className={`${footerStylesNoRecords} ${currentPath === '/home' ? 'text-center text-[var(--text-clr-no-transactions)]' : ' text-[#4B70B9] text-left'}`}>
                                  {(t('no_upcoming_transaction'))}
                                </div>}
                          </Tab>
                        </Tabs>
                      </div>
                    )
                  }
                  {
                    showFilterOverlay &&
                    (
                      <FilterSlider
                        selectedTab={selectedTab}
                        applyFilters={handleApplyFilters}
                        filterClose={onCloseFilter}
                        handleReset={handleClearFilters}
                        appliedFilters={filterData} />
                    )
                  }
                </div>
              </div>
            </>
          </DynamicCard>
        </div>
        <Modal
          isOpen={isOTPVerifyModalOpen}
          onClose={closeOTPVerifyModal}
          isLogo={false}
          subHeaderMsg={<p className="font-hanken-grotesk modal-title lg:text-[18px] md:text-[17px] sm:text-[15px] text-[14px] font-normal cursor-pointer pointer-events-none">{t("standard_msg_and_data_rates_may_apply")}</p>}
          title={<p className={HighlightMsgStyles}> {t("security_check_custom2fa")}</p>}
          subtitle={<p className={HeaderMsgStyles}>{t("we_are_sending_text")}</p>}
          content={<div className="mt-10"><Custom2FA type={t("activate_card")} onClose={closeOTPVerifyModal} verificationSuccess={verificationSuccess} verificationFailure={() => { }} /></div>}
        />
        {showModel &&
          <CustomAlertModel
            isOpen={showModel}
            onClose={closeModel}
            image={modelImage}
            highlightMsg={<p className={`${HighlightMsgStyles} sm:flex block flex-col`}>{highlightMsg}
              <span className={HeaderMsgStyles}> {headerMsg}</span></p>}
            subHeaderMsg={<p className={SubHeaderMsgStyles}>{subHeaderMsg}</p>}
            btn1Exists={btn1Exists}
            btn2Exists={btn2Exists}
            btn1Text={btn1Text} btn2Text={btn2Text}
            btn1TypeAcpt={btn1TypeAcpt}
            verificationFailure={() => { }}
            footerMsg={<p className={SubHeaderMsgStyles}>{footerMsg}</p>}
            onAcptBtnClick={onAcptBtnClick}
            subFooter={<p className={SubHeaderMsgStyles}>{subFooter}</p>}
            onCancelBtnClick={onCancelBtnClick}
            showErrorImg={showErrorImg}
            isBorderNone={isBorderNone}
            btn1Focus={btn1Focus}
            btn2Focus={btn2Focus}
          />
        }
        {loading && <Loader />}
      </HomeLayout>
    )
}

export default withOidcSecure(ManageRecurringPayments);
